import { render, staticRenderFns } from "./FieldConfiguratorFileTypes.vue?vue&type=template&id=10803d36&"
import script from "./FieldConfiguratorFileTypes.vue?vue&type=script&lang=js&"
export * from "./FieldConfiguratorFileTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports